import { GLOBAL_CSS } from "../constants/theme";

// ─── GLOBAL STYLES ────────────────────────────────────────────────────────────
// Injects the shared CSS once at the app root.
// Never duplicate <style>{GLOBAL_CSS}</style> in individual pages/components.

export default function GlobalStyles() {
  return <style>{GLOBAL_CSS}</style>;
}
